import React, {memo} from "react";
//  import FooterContainer from "./Default/Footer";
// import SharpFooter from "./Sharp/Footer";
const Footer = memo(({ matchFound, customerId ,theme}) => {
  console.log("customerId=>", customerId)
  // const config = new Map();
  // config.set("", <FooterContainer matchFound={matchFound} />);
  // config.set("HCF0999", <FooterContainer matchFound={matchFound} />);
  // config.set("HCF0331", <SharpFooter />);
  // let comp = config.get(customerId);

  
  if(theme){
    const LoadFooter=React.lazy(()=>import(`./${theme}/Footer`))
    return <LoadFooter matchFound={matchFound}/>;
  }
  else{
    return null
  }
 
});
export default Footer;
